<template>
	<div class='SecondaryColumn'>
		<div class="SecondaryColumnItem" v-for="(item) in list" :key="item.id">
			<!-- 嘉宾 -->
			<div class="item_box" v-if="item.type == 5">
				<div class="title_box" v-if="item.isTitleHide == 1">
					<span>{{item.title}}</span>
				</div>

				<div class="guest">
					<div class="title_box" v-if="item.isTitleHide == 1">
						<span>{{item.title}}</span>
					</div>

					<div :class="['guest_item_box', item.guest_item_box_expand && 'guest_item_box_expand_enough_height']">
						<div class="guest_item" v-for="(jtem, jndex) in item.lists" :key="jndex">
							<div class="avatar" v-if="jtem.head_img">
								<img :src="jtem.head_img" alt="">
							</div>
							<div :class="['info', !jtem.head_img && 'info_full']">
								<div class="name">{{jtem.name}}</div>
								<div class="desc">
									<pre>{{jtem.description}}</pre>
								</div>
							</div>
						</div>
					</div>

					<div class="expand" v-if="item.lists.length > 6" @click="item.guest_item_box_expand = !item.guest_item_box_expand;">
						<span>{{!item.guest_item_box_expand ? '展开' : '收起'}}</span>
						<div :class="['icon', item.guest_item_box_expand && 'icon_bak']"></div>
					</div>
				</div>
			</div>

			<!-- 视频 -->
			<div class="item_box" v-else-if="item.type == 18">
				<div class="title_box" v-if="item.isTitleHide == 1">
					<span>{{item.title}}</span>
				</div>

				<div class="video_content">
					<div class="swiper_box" v-if="item.lists">
						<swiper class="swiper" ref="swiper_video" :options="swiper_video_option">
							<swiperSlide class="swiper-slide" v-for="(jtem, jndex) in item.lists" :key="jndex">
								<div class="contain">
									<vue-aliplayer-v2
										:ref="`VueAliplayerV2_${jndex}`"
										class="VueAliplayerV2Style"
										:options="{...videoOptions, cover: jtem.videoPic}"
										:source="jtem.url"
										@ready="handleVideoReady"
									/>
									<div class="desc">{{jtem.abstracts}}</div>
								</div>
							</swiperSlide>

							<img class="swiper-button-prev swiper-button-prev_video" slot="button-prev" src="../../../../assets/images/shares/template_blue/icon_left.png" alt="">
							<img class="swiper-button-next swiper-button-next_video" slot="button-next" src="../../../../assets/images/shares/template_blue/icon_right.png" alt="">
						</swiper>
					</div>

					<div class="button_box">
						<div class="button" @click="handleVideoJump(item)">了解全部</div>
					</div>
				</div>
			</div>

			<div class="item_box" v-else-if="item.type == 20">
				<div class="title_box" v-if="item.isTitleHide == 1">
					<span>{{item.title}}</span>
				</div>

				<div class="cooperation">
					<div class="title_box" v-if="item.isTitleHide == 1">
						<span>合作机构</span>
					</div>

					<div class="cooperation_item_box">
						<div class="cooperation_item" v-for="(jtem, jndex) in JSON.parse(item.desc)" :key="jndex">{{jtem.name}}</div>
					</div>
				</div>
			</div>

			<!-- 图文 -->
			<div class="item_box" v-else-if="item.type == 21">
				<div class="title_box" v-if="item.isTitleHide == 1">
					<span>{{item.title}}</span>
				</div>

				<div class="pic_text_content" v-if="item.is_public == 0">
					<div class="swiper_box" v-if="item.lists">
						<swiper class="swiper" ref="swiper_pic_text" :options="swiper_pic_text_option">
							<swiperSlide class="swiper-slide" v-for="(jtem, jndex) in item.lists" :key="jndex">
								<div class="contain">
									<div class="img">
										<img class="img" :src="jtem.uploadImgId_url" alt="">
									</div>
									<div class="desc" @click="handlePicTextJump('detail', jtem)">{{jtem.summary}}</div>
								</div>
							</swiperSlide>

							<img class="swiper-button-prev swiper-button-prev_pic_text" slot="button-prev" src="../../../../assets/images/shares/template_blue/icon_left.png" alt="">
							<img class="swiper-button-next swiper-button-next_pic_text" slot="button-next" src="../../../../assets/images/shares/template_blue/icon_right.png" alt="">
						</swiper>
					</div>

					<div class="button_box">
						<div class="button" @click="handlePicTextJump('list', item)">了解全部</div>
					</div>
				</div>

				<div class="media_item_box" v-else-if="item.is_public == 1">
					<div class="media_item" :style="jtem.jump_status == 1 && {cursor: 'pointer'}" v-for="(jtem, jndex) in item.lists" :key="jndex" @click="handleMediaItemJump(jtem)">{{jtem.name}}</div>
				</div>
			</div>

			<!-- 直播 -->
			<div class="item_box" v-else-if="item.type == 22">
				<div class="title_box" v-if="item.isTitleHide == 1">
					<span>{{item.title}}</span>
				</div>

				<div class="live_streaming_viewer">

					<img v-if="item.is_public == 1" :src="item.is_full == 2 ? item.author : item.video_cover_url" alt="" @click="handleLiveStreamPicJump(item)">

					<div class="iframe" v-else-if="item.is_public == 3" v-html="item.content"></div>

					<vue-aliplayer-v2
						ref="VueAliplayerV2"
						class="VueAliplayerV2Style"
						v-else-if="item.is_public == 4 || item.is_full == 3"
						:options="{...videoOptions, cover: item.lists.videoPic}"
						:source="item.lists.videoUrl"
						@ready="handleVideoReady"
					/>

				</div>
			</div>

			<div class="item_box" v-else-if="item.type == 23">
				<div class="title_box" v-if="item.isTitleHide == 1">
					<span>{{item.title}}</span>
				</div>

				<div class="program" v-if="item.is_public == 1">
					<div :class="['agenda_item_box', item.agenda_item_box_expand && 'agenda_item_box_expand_enoughHeight']">
						<div class="agenda_content">
							<span v-html="item.content"></span>
						</div>
					</div>

					<div class="expand" @click="item.agenda_item_box_expand = !item.agenda_item_box_expand;">
						<span>{{!item.agenda_item_box_expand ? '展开' : '收起'}}</span>
						<div :class="['icon', item.agenda_item_box_expand && 'icon_bak']"></div>
					</div>
				</div>

				<div class="program" v-if="item.is_public == 2">
					<div :class="['agenda_item_box', item.timeline_expand && 'agenda_item_box_expand_enough_height']">
						<div class="agenda_item" v-for="(jtem, jndex) in item.dates" :key="jndex">
							<div class="title">{{jtem.date}}</div>

							<div class="timeline_item" v-for="(ktem, kndex) in jtem.timeline" :key="kndex">
								<div class="label">{{ktem.label}}</div>
								<div class="value" >
									<pre>{{ktem.info}}</pre>
								</div>
							</div>

						</div>
					</div>

					<div class="expand" @click="item.timeline_expand = !item.timeline_expand;">
						<span>{{!item.timeline_expand ? '展开' : '收起'}}</span>
						<div :class="['icon', item.timeline_expand && 'icon_bak']"></div>
					</div>
				</div>


			</div>
		</div>

	</div>
</template>
<script>

export default {
	name: 'SecondaryColumn',
	components: {

	},
	props: {
		list: Array
	},
	data() {
		return {
			videoOptions: {
				autoplay: false,
				// preload: true
				// playsinline: true,
				// useH5Prism: true,
				// isLive: false
			},
			swiper_pic_text_option: {
				navigation: {
					prevEl: '.swiper-button-prev_pic_text',
					nextEl: '.swiper-button-next_pic_text',
				},

			},
			swiper_video_option: {
				navigation: {
					prevEl: '.swiper-button-prev_video',
					nextEl: '.swiper-button-next_video',
				},
				on: {
					slideChangeTransitionEnd: () => {
						Object.keys(this.$refs).forEach(key => {
							if(key.indexOf('VueAliplayerV2') > -1){
								this.$refs[key][0].pause()
							}
						})
					}
				}
			},
		};
	},
	mounted() {
	},
	methods: {
		// 直播图片跳转
		handleLiveStreamPicJump(item){
			if(item.is_full != 1){
				window.location.href = item.jump_url
			}
		},

		// 资讯跳转
		handleMediaItemJump(item){
			if(item.jump_status == 1){
				window.location.href = item.jump_link
			} else {
				this.$router.push(`${this.$route.path}/detail?id=${item.id}`)
			}
		},
		// 图文跳转
		handlePicTextJump(type, item){
			if(type == 'detail'){
				this.$router.push(`${this.$route.path}/detail?id=${item.id}`)
			} else if (type == 'list'){
				this.$router.push(`${this.$route.path}/list?id=${item.id}`)
			}
		},
		// 视频跳转
		handleVideoJump(item){
			this.$router.push(`${this.$route.path}/videolist?id=${item.id}`)
		},
		handleOtherJump(item){
			if(item){
				this.$router.push(`${this.$route.path}/lsit?id=${item.id}`)
			}
		},
		handleVideoReady(e){
			console.log('handleVideoReady')
		}
	},
}
</script>
<style lang='stylus' scoped>
.SecondaryColumn
	width: 100%

	.SecondaryColumnItem
		.item_box
			width calc(100% - 1.34rem)
			margin auto

			.title_box
				width 100%
				// height 0.56rem
				margin auto
				margin-bottom: 0.4rem
				position relative

				&:before
					content ''
					width 0.11rem
					height 0.4rem
					border-radius: 0.08rem
					background-color: #67CBFF
					position absolute
					top 0.28rem

				span
					font-size: 0.43rem;
					font-family: Microsoft YaHei;
					font-weight: bold;
					line-height: 0.96rem;
					color: #67CBFF;
					margin-left: 0.24rem

			.VueAliplayerV2Style
				width 100%
				height 6.4rem !important
				// background-color unset !important
				display flex
				justify-content: space-around
				align-items: center

				>>>.prism-big-play-btn
					position unset !important
					left unset
					display flex
					justify-content: space-around
					align-items: center
					z-index 90

					.outter
						position unset

			.live_streaming
				padding-bottom: 1rem
				// background-color: #5D5D

				.live_streaming_content
					width 100%
					margin: auto

			.live_streaming_viewer
				width 100%
				height: 6.4rem
				margin-top: 0.8rem

				img
					width 100%
					height 100%
					cursor pointer

				.iframe
					width 100%

					>>> iframe
						width 100% !important
						height 6.4rem


			.agenda_item_box
				max-height: 14rem
				overflow: hidden
				transition all .1s ease

				.agenda_content
					font-size: 0.37rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					line-height: 0.64rem;
					color: #EEEEEE;

				.agenda_item
					margin-bottom: 0.5rem
					padding-bottom: 0.5rem
					border-bottom: 1px solid #fff

					.title
						font-size: 0.37rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #67CBFF;
						border-bottom: 1px dashed #fff
						padding-bottom: 0.12rem

					.timeline_item
						margin-top: 0.5rem
						display: flex
						justify-content: flex-start
						align-items: flex-start

						.label
							width 2rem
							font-size: 0.32rem;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 0.64rem;
							color: #EEEEEE;
							margin-right: 0.5rem
							text-align: center

						.value
							width calc(100% - 2.5rem)
							font-size: 0.32rem;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 0.64rem;
							color: #EEEEEE;

							pre
								font-size: 0.32rem;
								font-family: Microsoft YaHei;
								font-weight: 400;
								line-height: 0.64rem;
								color: #EEEEEE;
								text-align: justify

						.agenda_item_box_max_height_auto
							max-height: 100rem

			.expand
				padding-top: 0.6rem
				display: flex
				flex-direction: column
				justify-content: flex-start
				align-items: center
				cursor: pointer
				transition all 0.1s ease

				span
					font-size: 0.32rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #67CBFF;

				.icon
					margin-top: 0.02rem
					margin-bottom: 0.37rem
					border-top: 0.16rem solid #67CBFF
					border-bottom: 0 solid transparent
					border-left: 0.135rem solid transparent
					border-right: 0.135rem solid transparent

				.icon_bak
					transform:rotate(180deg)

			.agenda_item_box_expand
				max-height: 100rem

			.guest_item_box
				max-height: 21.36rem
				margin-bottom: 0.5rem
				overflow hidden
				transition all .1s ease

				.guest_item
					width 100%
					min-height 3rem
					margin-bottom 0.53rem
					background-color: #15416A
					display: flex
					justify-content: flex-start
					align-items: center
					border-radius: 0.27rem

					.avatar
						width 2.4rem
						height 100%
						display block

						img
							border-radius: 0.27rem

					.info
						font-size: 0.32rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						line-height: 0.43rem;
						color: #67CBFF;
						width calc(100% - 2.4rem)
						height 100%
						padding 0 0.27rem
						display: flex
						flex-direction: column
						justify-content: space-around
						align-items: flex-start

						.name
							width 100%
							font-size: 0.43rem;
							font-family: Microsoft YaHei;
							font-weight: bold;
							line-height: 0.96rem;
							color: #FFFFFF;
							overflow: hidden
							text-overflow: ellipsis
							white-space: nowrap

						.desc
							font-size: 0.32rem;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 0.43rem;
							color: #67CBFF;
							width 5.5rem
							height 1.7rem
							text-overflow: ellipsis
							overflow: hidden
							white-space: nowrap
							display:-webkit-box;
							-webkit-line-clamp 4
							-webkit-box-orient:vertical;
							text-align: justify

					.info_full
						width 100%
						.desc
							width 100%


			.agenda_item_box_expand_enough_height
				max-height: 100rem

			.expand
				display: flex
				flex-direction: column
				justify-content: flex-start
				align-items: center
				cursor: pointer

				span
					font-size: 0.32rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #67CBFF;

				.icon
					margin-top: 0.02rem
					margin-bottom: 0.37rem
					border-top: 0.16rem solid #67CBFF
					border-bottom: 0 solid transparent
					border-left: 0.135rem solid transparent
					border-right: 0.135rem solid transparent

				.icon_bak
					transform:rotate(180deg)


			.cooperation
				.title_box
					background-image: unset
					position relative

					&:before
						content ''
						width 0.11rem
						height 0.4rem
						border-radius: 0.08rem
						background-color: #67CBFF
						position absolute
						top 0.28rem

					span
						font-size: 0.43rem;
						font-family: Microsoft YaHei;
						font-weight: bold;
						line-height: 0.96rem;
						color: #67CBFF;
						margin-left: 0.24rem

			.cooperation_item_box
				margin-top: 0.77rem
				margin-left: 0.8rem

				.cooperation_item
					font-size: 0.32rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					line-height: 0.64rem;
					color: #FFFFFF;
					position relative

					&::before
						content ''
						width 0.13rem
						height 0.13rem
						border-radius: 50%
						background-color: #00A8FF;
						position absolute
						left -0.4rem
						top 0.24rem


				.report_content
					width 100%

					.pic_text

						.title_box
							background-image: unset
							margin-top: 0.8rem
							position relative

							&:before
								content ''
								width 0.11rem
								height 0.4rem
								border-radius: 0.08rem
								background-color: #67CBFF
								position absolute
								top 0.28rem

							span
								font-size: 0.43rem;
								font-family: Microsoft YaHei;
								font-weight: bold;
								line-height: 0.96rem;
								color: #67CBFF;
								margin-left: 0.24rem

			.pic_text_content
				.swiper_box
					// .swiper

					.swiper-button-prev_pic_text
						width 0.25rem
						height 0.45rem
						position absolute
						top calc(50% - 0.6rem)
						left 0
						background-image: unset
					.swiper-button-next_pic_text
						width 0.25rem
						height 0.45rem
						position absolute
						top calc(50% - 0.6rem)
						right 0
						background-image: unset

					.contain
						width calc(100% - 1.4rem)
						margin auto

						.img
							width 100%
							height 4.16rem
							border-radius: .27rem

						.desc
							font-size: 0.32rem;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 0.48rem;
							color: #EEEEEE;
							margin-top: 0.27rem
							// text-align: justify
							width 100%
							height 1.4rem
							cursor: pointer
							overflow:hidden;
							text-overflow:ellipsis;
							display:-webkit-box;
							-webkit-box-orient:vertical;
							-webkit-line-clamp: 3

				.button_box
					width 7.25rem
					margin auto
					margin-top: 0.27rem
					display flex
					justify-content flex-end
					align-items center

					.button
						font-size: 0.32rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						line-height: 0.64rem;
						color: #FFFFFF;
						width: 2.13rem;
						height: 0.67rem;
						background: #0C88C8;
						border-radius: 0.35rem
						cursor pointer
						display flex
						justify-content: space-around
						align-items: center

			.video_content

				.swiper_box
					.VueAliplayerV2Style
						width 100%
						height 5.3rem !important
						// background-color unset !important
						display flex
						justify-content: space-around
						align-items: center

						>>>.prism-big-play-btn
							position unset !important
							left unset
							display flex
							justify-content: space-around
							align-items: center
							z-index 90

							.outter
								position unset

					.swiper-button-prev_video
						width 0.25rem
						height 0.45rem
						position absolute
						top calc(50% - 0.6rem)
						left 0
						background-image: unset
					.swiper-button-next_video
						width 0.25rem
						height 0.45rem
						position absolute
						top calc(50% - 0.6rem)
						right 0
						background-image: unset

					.contain
						width 7.25rem
						margin auto

						.video
							width 7.25rem
							height 4.16rem
							border-radius: .27rem

						.desc
							font-size: 0.32rem;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 0.48rem;
							color: #EEEEEE;
							margin-top: 0.27rem
							// text-align: justify;
							text-justify: inter-ideograph;
							width 100%
							overflow:hidden;
							text-overflow: ellipsis
							display:-webkit-box;
							-webkit-box-orient: vertical
							-webkit-line-clamp: 3

				.button_box
					width 7.25rem
					margin auto
					margin-top: 0.27rem
					display flex
					justify-content flex-end
					align-items center

					.button
						font-size: 0.32rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						line-height: 0.64rem;
						color: #FFFFFF;
						width: 2.13rem;
						height: 0.67rem;
						background: #0C88C8;
						border-radius: 0.35rem
						display flex
						justify-content: space-around
						align-items: center

					.media

						.title_box
							background-image: unset
							margin-top: 0.8rem
							position relative

							&:before
								content ''
								width 0.11rem
								height 0.4rem
								border-radius: 0.08rem
								background-color: #67CBFF
								position absolute
								top 0.28rem

							span
								font-size: 0.43rem;
								font-family: Microsoft YaHei;
								font-weight: bold;
								line-height: 0.96rem;
								color: #67CBFF;
								margin-left: 0.24rem

		.media_item_box
			margin-left: 0.8rem

			.media_item
				font-size: 0.37rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				line-height: 0.48rem;
				color: #EEEEEE;
				position relative
				margin-bottom: 0.4rem
				display: block
				cursor pointer
				text-align: justify

				&::before
					content ''
					width 0.13rem
					height 0.13rem
					border-radius: 50%
					background-color: #00A8FF;
					position absolute
					left -0.4rem
					top 0.164rem

			.review
				background-color: #5D5D5D

				.review_content
					width 100%
					padding-bottom: 2.19rem

					.review_item_box
						margin-top: 0.77rem
						margin-left: 0.8rem

						.review_item
							font-size: 0.37rem;
							font-family: Microsoft YaHei;
							font-weight: 400;
							line-height: 0.64rem;
							color: #EEEEEE;
							position relative
							margin-top: 0.4rem

							&::before
								content ''
								width 0.13rem
								height 0.13rem
								border-radius: 50%
								background-color: #00A8FF;
								position absolute
								left -0.4rem
								top 0.24rem
</style>
